import PersonalInformationForm from '@/features/onboarding/personal-information/components/form';
import PersonalInformationLayout from '@/features/onboarding/personal-information/layout';

const PersonalInformationPage = () => {
  return (
    <PersonalInformationLayout>
      <PersonalInformationForm />
    </PersonalInformationLayout>
  );
};
PersonalInformationPage.displayName = 'PersonalInformationPage';

export default PersonalInformationPage;
